import { Directive, ElementRef, KeyValueDiffers, Input, NgModule } from '@angular/core';

/**
 * Created by greg on 21/10/16.
 */
import * as ɵngcc0 from '@angular/core';
class Ng2HighchartsBase {
    constructor(ele, _differs) {
        this.hostElement = ele;
        this.differ = _differs.find({}).create();
    }
    get chart() {
        return this.pChart;
    }
    reflow() {
        if (!this.pChart || !this.options) {
            return;
        }
        if (getComputedStyle(this.hostElement.nativeElement).transitionDuration) {
            var duration = parseFloat(getComputedStyle(this.hostElement.nativeElement).transitionDuration);
            var interval = setInterval(() => {
                if (duration < 0) {
                    clearInterval(interval);
                }
                duration -= 50;
                try {
                    this.pChart.reflow();
                }
                catch (e) {
                    // all right - component probably has been deleted.
                    clearInterval(interval);
                }
            }, duration);
        }
        this.pChart.reflow();
    }
    ngDoCheck() {
        if (this.currentWidth !== this.hostElement.nativeElement.offsetWidth) {
            this.reflow();
            this.currentWidth = this.hostElement.nativeElement.offsetWidth;
        }
        if (this.currentHeight !== this.hostElement.nativeElement.offsetHeight) {
            this.reflow();
            this.currentHeight = this.hostElement.nativeElement.offsetHeight;
        }
        if (this.differ.diff(this.options)) {
            this.draw(this.options);
        }
    }
    ngOnDestroy() {
        if (this.pChart) {
            this.pChart.destroy();
        }
    }
}
Ng2HighchartsBase.ɵfac = function Ng2HighchartsBase_Factory(t) { return new (t || Ng2HighchartsBase)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers)); };
Ng2HighchartsBase.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: Ng2HighchartsBase, inputs: { options: ["ng2-highcharts", "options"] } });
Ng2HighchartsBase.ctorParameters = () => [
    { type: ElementRef },
    { type: KeyValueDiffers }
];
Ng2HighchartsBase.propDecorators = {
    options: [{ type: Input, args: ['ng2-highcharts',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Ng2HighchartsBase, [{
        type: Directive,
        args: [{}]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.KeyValueDiffers }]; }, { options: [{
            type: Input,
            args: ['ng2-highcharts']
        }] }); })();

class Ng2Highcharts extends Ng2HighchartsBase {
    constructor(ele, _differs) {
        super(ele, _differs);
    }
    draw(opt /* HighchartsOptions */) {
        if (!opt) {
            console.log('No valid options...');
            console.log(opt);
            return;
        }
        if (opt.series || opt.data) {
            if (this.pChart) {
                this.pChart.destroy();
            }
            if (!opt.chart) {
                opt.chart = {};
            }
            opt.chart.renderTo = this.hostElement.nativeElement;
            this.pChart = new window.Highcharts.Chart(opt);
        }
        else {
            console.log('No valid options...');
            console.dir(opt);
        }
    }
}
Ng2Highcharts.ɵfac = function Ng2Highcharts_Factory(t) { return new (t || Ng2Highcharts)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers)); };
Ng2Highcharts.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: Ng2Highcharts, selectors: [["", "ng2-highcharts", ""]], inputs: { options: ["ng2-highcharts", "options"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
Ng2Highcharts.ctorParameters = () => [
    { type: ElementRef },
    { type: KeyValueDiffers }
];
Ng2Highcharts.propDecorators = {
    options: [{ type: Input, args: ['ng2-highcharts',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Ng2Highcharts, [{
        type: Directive,
        args: [{
                selector: '[ng2-highcharts]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.KeyValueDiffers }]; }, { options: [{
            type: Input,
            args: ['ng2-highcharts']
        }] }); })();

class Ng2Highmaps extends Ng2HighchartsBase {
    constructor(ele, _differs) {
        super(ele, _differs);
    }
    draw(opt /* HighchartsOptions */) {
        if (!opt) {
            console.log('No valid options...');
            console.log(opt);
            return;
        }
        if (opt.series || opt.data) {
            if (this.pChart) {
                this.pChart.destroy();
            }
            if (!opt.chart) {
                opt.chart = {};
            }
            opt.chart.renderTo = this.hostElement.nativeElement;
            this.pChart = new window.Highcharts.Map(opt);
        }
        else {
            console.log('No valid options...');
            console.dir(opt);
        }
    }
}
Ng2Highmaps.ɵfac = function Ng2Highmaps_Factory(t) { return new (t || Ng2Highmaps)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers)); };
Ng2Highmaps.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: Ng2Highmaps, selectors: [["", "ng2-highmaps", ""]], inputs: { options: ["ng2-highmaps", "options"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
Ng2Highmaps.ctorParameters = () => [
    { type: ElementRef },
    { type: KeyValueDiffers }
];
Ng2Highmaps.propDecorators = {
    options: [{ type: Input, args: ['ng2-highmaps',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Ng2Highmaps, [{
        type: Directive,
        args: [{
                selector: '[ng2-highmaps]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.KeyValueDiffers }]; }, { options: [{
            type: Input,
            args: ['ng2-highmaps']
        }] }); })();

class Ng2Highstocks extends Ng2HighchartsBase {
    constructor(ele, _differs) {
        super(ele, _differs);
    }
    draw(opt /* HighchartsOptions */) {
        if (!opt) {
            console.log('No valid options...');
            console.log(opt);
            return;
        }
        if (opt.series || opt.data) {
            if (this.pChart) {
                this.pChart.destroy();
            }
            if (!opt.chart) {
                opt.chart = {};
            }
            opt.chart.renderTo = this.hostElement.nativeElement;
            this.pChart = new window.Highcharts.StockChart(opt);
        }
        else {
            console.log('No valid options...');
            console.dir(opt);
        }
    }
}
Ng2Highstocks.ɵfac = function Ng2Highstocks_Factory(t) { return new (t || Ng2Highstocks)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers)); };
Ng2Highstocks.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: Ng2Highstocks, selectors: [["", "ng2-highstocks", ""]], inputs: { options: ["ng2-highstocks", "options"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
Ng2Highstocks.ctorParameters = () => [
    { type: ElementRef },
    { type: KeyValueDiffers }
];
Ng2Highstocks.propDecorators = {
    options: [{ type: Input, args: ['ng2-highstocks',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Ng2Highstocks, [{
        type: Directive,
        args: [{
                selector: '[ng2-highstocks]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.KeyValueDiffers }]; }, { options: [{
            type: Input,
            args: ['ng2-highstocks']
        }] }); })();

class Ng2HighchartsModule {
}
Ng2HighchartsModule.ɵfac = function Ng2HighchartsModule_Factory(t) { return new (t || Ng2HighchartsModule)(); };
Ng2HighchartsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: Ng2HighchartsModule });
Ng2HighchartsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Ng2HighchartsModule, [{
        type: NgModule,
        args: [{
                declarations: [Ng2Highcharts, Ng2Highmaps, Ng2Highstocks],
                exports: [Ng2Highcharts, Ng2Highmaps, Ng2Highstocks]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(Ng2HighchartsModule, { declarations: [Ng2Highcharts, Ng2Highmaps, Ng2Highstocks], exports: [Ng2Highcharts, Ng2Highmaps, Ng2Highstocks] }); })();

/*
 * Public API Surface of ng2-highcharts
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Ng2Highcharts, Ng2HighchartsModule, Ng2Highmaps, Ng2Highstocks, Ng2HighchartsBase as ɵa };

